import React from "react";
import Routes from "routing/Routes";
import { Col, Row } from "components/bootstrap";
import SecurityRoutes from "security-app/routing/Routes";
import { TELEMETRY_EVENT_TYPE } from "logic/telemetry/Constants";
import FormContainer from "security-app/components/SigmaRules/SigmaEventDefinitions/FormContainer";
import { PAGE_NAVIGATION_TITLE, NOTIFICATIONS_TITLE } from "components/events/bindings";
import useLicenseCheck from "license/useLicenseCheck";
import SigmaEventDefinitionSearchAction from "./SigmaEventDefinitionSearchAction";
import SigmaEventDefinitionsOptions from "./SigmaEventDefinitionsOptions";
export const SIGMA_ENTITY_CREATORS = {
  GIT_IMPORT: "Sigma Git Import",
  FILE_IMPORT: "Sigma File Import"
};
const SIGMA_REPOS_TITLE = "Sigma Repos";
const sigmaBindings = {
  "eventDefinitions.components.sigmaOptions": [
    {
      component: SigmaEventDefinitionsOptions,
      key: "eventDefinitionsSigmaOptions"
    }
  ],
  "eventDefinitions.components.sigmaGitImport": [
    {
      component: () => /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(FormContainer, { pathAction: "git-import" }))),
      key: "sigmaGitImportForm"
    }
  ],
  "eventDefinitions.components.sigmaFileUpload": [
    {
      component: () => /* @__PURE__ */ React.createElement(Row, { className: "content" }, /* @__PURE__ */ React.createElement(Col, { md: 12 }, /* @__PURE__ */ React.createElement(FormContainer, { pathAction: "file-import" }))),
      key: "sigmaFileUploadForm"
    }
  ],
  "components.shared.entityActions": [
    {
      component: SigmaEventDefinitionSearchAction,
      key: "sigma-search-logs"
    }
  ],
  entityCreators: [
    {
      id: SIGMA_ENTITY_CREATORS.GIT_IMPORT,
      title: "Sigma Git Import",
      path: Routes.ALERTS.DEFINITIONS.SIGMA.GIT_IMPORT,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.EVENTDEFINITION_CREATE_BUTTON_CLICKED,
        section: "event-definitions",
        actionValue: "create-event-definition-button"
      },
      permissions: ["eventdefinitions:create", "sigma_repository:read"]
    },
    {
      id: SIGMA_ENTITY_CREATORS.FILE_IMPORT,
      title: "Sigma File Import",
      path: Routes.ALERTS.DEFINITIONS.SIGMA.FILE_IMPORT,
      telemetryEvent: {
        type: TELEMETRY_EVENT_TYPE.EVENTDEFINITION_CREATE_BUTTON_CLICKED,
        section: "event-definitions",
        actionValue: "create-event-definition-button"
      },
      permissions: "eventdefinitions:create"
    }
  ],
  "pageNavigation": [
    {
      description: PAGE_NAVIGATION_TITLE,
      children: [
        {
          description: SIGMA_REPOS_TITLE,
          path: SecurityRoutes.SIGMA.CONFIGURATION,
          permissions: ["sigma_repository:read"],
          position: { after: NOTIFICATIONS_TITLE },
          useCondition: () => {
            const {
              security: { isValid: isValidSecurityLicense }
            } = useLicenseCheck();
            return isValidSecurityLicense;
          }
        }
      ]
    }
  ]
};
export default sigmaBindings;
